module.exports = __webpack_public_path__ + "static/media/discard-delete-red.913d4003.svg";